module.exports = __webpack_public_path__ + "public/SiteIcons/shareTwitter.svg?9c57c8d2";